import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './layout/';
import '@src/common/resetMobile.css';

/* eslint-disable */
ReactDOM.hydrate(<Layout content={allData} />, document.getElementById('root'));
/* eslint-enable */
